module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-cookie-60a8c6b9fc76b2b6268e712ae2d3a1f3.svg";